module.exports = __webpack_public_path__ + "img/business_20.d3ed95e6.jpg";